import clsx from 'clsx'
import { type Driver, type DriveStep, driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { themeClass } from '~/styles/theme.css'
import { driverPopover } from './GuidedTour.css'

const isStepVisible = (step: DriveStep) => {
  if (typeof step.element !== 'string') {
    return true
  }
  const element = document.querySelector(step.element)
  if (!element) {
    return false
  }
  const rect = element.getBoundingClientRect()
  return rect.width > 0 || rect.height > 0
}

/** Starts a driver.js tour, skipping the steps whose element is missing or hidden. */
export const startGuidedTour = (steps: DriveStep[]): Driver => {
  const tour = driver({
    showProgress: true,
    showButtons: ['next', 'previous', 'close'],
    steps: steps.filter(isStepVisible),
    popoverClass: clsx(themeClass, driverPopover),
    progressText: '{{current}} sur {{total}}',
    nextBtnText: 'Suivant',
    prevBtnText: 'Précédent',
    doneBtnText: 'Terminer'
  })
  tour.drive()
  return tour
}
